import React from "react"
import clsx from "clsx"
import { Absolute } from "ui/components/atoms/_atoms"
import Icon from "ui/components/atoms/icon"
import Spinner from "ui/components/atoms/spinner"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./IconButton.module.css"

export type IconButtonProps = BaseStyles & {
  icon: string
  onClick?: () => void
  className?: string
  ariaLabel: string
  style?: React.CSSProperties
  loading?: boolean
  disabled?: boolean
  $size?: string
  $iconSize?: string
  $background?: string
  $hoverColor?: string
  $hoverBackground?: string
  $color?: string
}

export const IconButton = ({
  icon,
  onClick,
  style = {},
  loading,
  disabled,
  ariaLabel,
  $color = "second",
  $size = "XXXL",
  $iconSize = "S",
  $background = "background",
  $hoverColor,
  $hoverBackground,
  className = "",
  ...rest
}: IconButtonProps) => {
  const generatedStyles = generateStylesFromProps({
    ...rest,
    $color,
    $size,
    $background,
  })

  const buttonClasses = clsx(
    styles.iconButton,
    {
      [styles.noBg]: $background === "none",
    },
    className,
  )

  const buttonStyles = {
    ...generatedStyles,
    ...style,
  }

  return (
    <button
      onClick={onClick}
      style={buttonStyles}
      aria-label={ariaLabel}
      disabled={disabled}
      className={buttonClasses}
      data-hover-background={$hoverBackground}
      data-hover-color={$hoverColor}
    >
      <Icon icon={icon} $color={$color} $opacity={loading ? 0 : 1} $size={$iconSize} />
      {loading && (
        <Absolute
          $width="100%"
          $height="100%"
          $left="0"
          $top="0"
          $display="flex"
          $alignItems="center"
          $justifyContent="center"
        >
          <Spinner $color={$color} $size="20px" />
        </Absolute>
      )}
    </button>
  )
}
